import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Бонусы нужны, чтобы увеличивать ставку по заявкам", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Спасибо за регистрацию на портале для перевозчиков GT2!", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Вы сможете взять первую заявку и использовать бонусы после создания организации.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Предложение действует для определенных категорий перевозчиков.", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ui_modal_with_content = _resolveComponent("ui-modal-with-content")!

  return (_openBlock(), _createBlock(_component_ui_modal_with_content, {
    target: "modal",
    "overlay-color": "dark-blue",
    "has-custom-container-style": "",
    width: 600,
    class: _normalizeClass(_ctx.$style.container),
    onClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.container)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.imgWrapper)
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.content)
        }, [
          _createElementVNode("h1", {
            class: _normalizeClass(_ctx.$style.title)
          }, _toDisplayString(_ctx.counterparty ? 'Вам начислено 1000 бонусов!' : 'Дарим 1000 бонусов на любую заявку!'), 3),
          (_ctx.counterparty)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.$style.text)
                }, " Ваша организация успешно согласована, и теперь вам доступны все функции Портала GT2! ", 2),
                _hoisted_2
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", null, [
                  _hoisted_3,
                  _createTextVNode(" В качестве приветственного подарка мы дарим вам "),
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.$style.cashbackValue)
                  }, "1000 бонусов", 2),
                  _createTextVNode(", которыми вы можете увеличить ставку. ")
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style.additionalText)
                }, _hoisted_6, 2)
              ], 64)),
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
          }, [
            (!_ctx.counterparty)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: _ctx.getOrgRoute(),
                  class: _normalizeClass(_ctx.$style.link)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ui_button, {
                      class: _normalizeClass(_ctx.$style.button)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Перейти к созданию Организации ")
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _: 1
                }, 8, ["to", "class"]))
              : (_openBlock(), _createBlock(_component_ui_button, {
                  key: 1,
                  class: _normalizeClass([_ctx.$style.button, _ctx.$style.closeButton])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Перейти к поиску заявки ")
                  ]),
                  _: 1
                }, 8, ["class"]))
          ])
        ], 2)
      ], 2)
    ]),
    _: 1
  }, 8, ["class", "onClose"]))
}